import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { youtubeId, embedUrl } from './youtube';

// Page text for the public website (editable pages, hills, archive) and the
// Web Admin preview. react-markdown never renders raw HTML, so whatever an
// editor types can't inject script. Headings get ids (#june-1999) so pages
// can link to a section.
//
// The one embed allowed: an image whose address is a YouTube video,
//   ![Hill Climb: a lesson in time](https://www.youtube.com/watch?v=C7F52rsYoUU)
// shows YouTube's privacy-enhanced (no-cookie) player for that video.

function slugify(children) {
  const text = [].concat(children).map(c => (typeof c === 'string' ? c : c?.props?.children ?? '')).join('');
  return String(text).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}

function heading(Tag) {
  return function Heading({ children }) {
    return <Tag id={slugify(children)}>{children}</Tag>;
  };
}

function Link({ href = '', children }) {
  // PDFs (including the documents, /documents/<slug>.pdf) open in a new tab.
  const external = /^https?:\/\//.test(href) || href.endsWith('.pdf') || href.startsWith('/api/');
  return external
    ? <a href={href} target="_blank" rel="noreferrer">{children}</a>
    : <a href={href}>{children}</a>;
}

function Image({ src = '', alt }) {
  const video = youtubeId(src);
  if (video) {
    return (
      <span className="site-video">
        <iframe
          src={embedUrl(video)}
          title={alt || 'Video'}
          loading="lazy"
          allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
        />
        {alt && <span className="site-video-caption">{alt}</span>}
      </span>
    );
  }
  return <img src={src} alt={alt || ''} loading="lazy" />;
}

const COMPONENTS = { h2: heading('h2'), h3: heading('h3'), h4: heading('h4'), a: Link, img: Image };

export default function Markdown({ children }) {
  return (
    <div className="site-prose">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={COMPONENTS}>{children || ''}</ReactMarkdown>
    </div>
  );
}
